/**
 * Middleware global de separación por dominio
 *
 * - comandaplus.com       → Landing pública (solo /, /auth, /r/*)
 * - app.comandaplus.com   → Aplicación (dashboard, caja, salón, etc.)
 *
 * En desarrollo (localhost) no aplica ninguna restricción.
 */
export default defineNuxtRouteMiddleware((to) => {
  // Solo ejecutar en cliente (el host viene del navegador)
  if (import.meta.server) return

  const host = window.location.hostname

  // En desarrollo no restringir
  if (host === 'localhost' || host === '127.0.0.1' || host.includes('192.168')) return

  const isAppDomain = host.startsWith('app.')
  const isMainDomain = !isAppDomain && (host === 'comandaplus.com' || host === 'www.comandaplus.com')

  // Rutas que pertenecen a la landing (dominio principal)
  const landingRoutes = ['/', '/auth', '/create-profile', '/onboarding']
  const isLandingRoute = landingRoutes.includes(to.path) || to.path.startsWith('/auth/')

  // Rutas públicas del cliente (QR) — funcionan en ambos dominios
  const isPublicClientRoute = to.path.startsWith('/r/')
  // Rutas del menú público
  const isMenuRoute = to.path.startsWith('/menu/')
  // Ticket/justificante por comensal (se abre escaneando un QR) — ambos dominios
  const isReciboRoute = to.path.startsWith('/recibo/')

  if (isPublicClientRoute || isMenuRoute || isReciboRoute) return

  // Si estamos en el dominio principal y la ruta es de la app → redirigir a app.
  if (isMainDomain && !isLandingRoute) {
    const appUrl = `https://app.comandaplus.com${to.fullPath}`
    return navigateTo(appUrl, { external: true })
  }

  // Si estamos en app. y la ruta es de landing → redirigir al dominio principal
  if (isAppDomain && isLandingRoute) {
    // Excepción: /auth y /create-profile deben funcionar en app. también
    if (to.path === '/auth' || to.path.startsWith('/auth/') || to.path === '/create-profile' || to.path === '/onboarding') return

    const mainUrl = `https://comandaplus.com${to.fullPath}`
    return navigateTo(mainUrl, { external: true })
  }
})
